/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Response } from '@app/models';
import { AdminComplianceService } from './compliance.service';

@Injectable()
export class AdminBscBatchResolverService implements Resolve<Response> {
  constructor(private adminComplianceService: AdminComplianceService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    if (route.params.year && route.params.quarter) {
      return this.adminComplianceService.getBatch(route.params.year, route.params.quarter).pipe(
        take(1),
        map(res => {
          if (res.error === false) return res['data'];
          else return false;
        })
      );
    } else {
      return false;
    }
  }
  
}
